import { createContext, useContext } from 'react'

export const NonceContext = createContext(undefined)

export const useNonce = () => {
  const nonce = useContext(NonceContext)
  return nonce
}
